import { ndcAllowedRoles } from 'data/facts/userRolesValidations';
import { NDCFormFieldsTypes } from 'Interfaces/FactsInterfaces/drugInterfaces';
import { moduleTypes, roleInstance } from 'Interfaces/roleBasedAccessInterfaces';

export const checkIfFunctionalityEnabled = (
  allowedRoles: roleInstance[],
  moduleRoles: roleInstance[],
  userModulesRoles: { [key in moduleTypes]: roleInstance[] }
) => {
  let roleMatched = false;

  if (userModulesRoles.plm.length > 0) {
    return true;
  }

  for (let i = 0; i < allowedRoles.length; i++) {
    for (let j = 0; j < moduleRoles.length; j++) {
      if (allowedRoles[i] && moduleRoles[j])
        if (
          allowedRoles[i]?.role == moduleRoles[j]?.role &&
          allowedRoles[i]?.department == moduleRoles[j]?.department
        ) {
          roleMatched = true;
        }
    }
    if (roleMatched) break;
  }
  return roleMatched;
};

export const checkIfNDCStrategyAddEnabled = (
  strategyType: NDCFormFieldsTypes,
  moduleRoles: roleInstance[],
  userModulesRoles: { [key in moduleTypes]: roleInstance[] }
) => {
  if (strategyType === 'PPS' || strategyType === 'PPSSC') {
    return checkIfFunctionalityEnabled(
      ndcAllowedRoles.newPpsPpsStrategyAdd,
      moduleRoles,
      userModulesRoles
    );
  } else {
    return checkIfFunctionalityEnabled(
      ndcAllowedRoles.newDpStrategyAdd,
      moduleRoles,
      userModulesRoles
    );
  }
};

export const checkIfNDCStrategyEditEnabled = (
  strategyType: NDCFormFieldsTypes,
  moduleRoles: roleInstance[],
  userModulesRoles: { [key in moduleTypes]: roleInstance[] }
) => {
  if (strategyType === 'PPS' || strategyType === 'PPSSC') {
    return checkIfFunctionalityEnabled(
      ndcAllowedRoles.ppsPpsStrategyEdit,
      moduleRoles,
      userModulesRoles
    );
  } else {
    return checkIfFunctionalityEnabled(
      ndcAllowedRoles.segmentationEdit,
      moduleRoles,
      userModulesRoles
    );
  }
};
